import React from 'react';
import {post} from '../../utils/request';
import api from './api';
import './index.less';

class customerServiceCenterDetail extends React.Component {
  constructor(props) {
    super(...props);
    this.state = {
        urlOps: {},
        data: {}
    }
  }
  componentWillMount() {
    var obj = '',obj1 = '',ops={};
    if(window.location.hash.indexOf('?') > -1 ){
        obj = window.location.hash.split('?')[1];
        obj1 = obj.split('&');
        for(var i=0;i<obj1.length;i++){
            ops[obj1[i].split('=')[0]] = obj1[i].split('=')[1] === 'undefined' ? '' : obj1[i].split('=')[1];
        }
        this.setState({
            urlOps: ops
        },()=>{
            this.getView();
        });
    }
  }

  getView(){
    post({
      url: api.getView,
      data:{
        contentId: this.state.urlOps.id
      },
      preventXXSKey: 'contentRemark'
    }).then((res) => {
        console.log('常见问题详情', res)
        // Toast.info(res.msg,1);
        if(res.result === 'success' && res.data){
            this.setState({
                data: res.data
            });
        }else{

        }
    }, (res)=>{
        console.log('常见问题详情失败', res)
    });
  }

  render() {
    const { data } = this.state;
    return (
      <div className="customerServiceCenterDetailBox">
          <div className="contentBox">
            <h1>{data.contentTitle}</h1>
            <div className="contentHtml" dangerouslySetInnerHTML={{__html: data.contentRemark}}></div>
          </div>
          <div className="notSolved">没有解决问题？试试<a href="tel:4008262266">联系客服</a></div>
      </div>
    );
  }
}

export default customerServiceCenterDetail;


// WEBPACK FOOTER //
// ./src/customerServiceCenter/detail/index.js